module.exports = __webpack_public_path__ + "b7cf8cf01f9576b34f5dd5d1e2a14282.svg";